import React from 'react'
import { Link, useParams } from 'react-router-dom'
import servicesData from '../data/servicesData'

export default function ServiceDetail() {
  const { slug } = useParams()
  const service = servicesData.find(s => s.slug === slug)

  if (!service) return (
    <div className="flex flex-col items-center justify-center py-32 px-6 text-center">
      <div className="text-6xl mb-4">🔍</div>
      <h2 className="text-2xl font-bold mb-2" style={{color:'var(--navy)',fontFamily:'Playfair Display,serif'}}>Service Not Found</h2>
      <p className="mb-6 text-sm" style={{color:'var(--muted)'}}>The page you are looking for does not exist.</p>
      <Link to="/initiatives" className="inline-flex items-center gap-2 text-white px-6 py-3 rounded-full text-sm font-semibold" style={{background:'var(--saffron)'}}>
        ← Back to Initiatives
      </Link>
    </div>
  )

  return (
    <div>
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-4">
          <h1>{service.title}</h1>
          <p className="breadcrumb">Home › Initiatives › {service.title}</p>
        </div>
      </div>

      <section className="py-16" style={{background:'var(--cream)'}}>
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-4 gap-8 items-start">

          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="rounded-2xl overflow-hidden sticky top-24" style={{background:'white',border:'1px solid rgba(0,0,0,0.07)',boxShadow:'0 4px 20px rgba(13,27,62,0.06)'}}>
              <div className="px-5 py-4 font-semibold text-xs tracking-widest uppercase" style={{background:'var(--navy)',color:'white'}}>
                All Initiatives
              </div>
              {servicesData.map(item => (
                <Link key={item.slug} to={`/service/${item.slug}`}
                  className="flex items-center justify-between px-5 py-3.5 text-sm transition-all"
                  style={{
                    borderBottom:'1px solid rgba(0,0,0,0.05)',
                    color: item.slug === slug ? 'var(--saffron)' : 'var(--text)',
                    background: item.slug === slug ? 'var(--saffron-pale)' : 'white',
                    fontWeight: item.slug === slug ? 600 : 400,
                  }}>
                  <span>{item.title}</span>
                  <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
                </Link>
              ))}
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3 space-y-6">
            {/* Main content card */}
            <div className="rounded-2xl p-8 sm:p-10" style={{background:'white',border:'1px solid rgba(0,0,0,0.07)',boxShadow:'0 4px 20px rgba(13,27,62,0.06)'}}>
              <div className="section-tag">{service.title}</div>
              <h2 className="mb-5" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(24px,3.5vw,36px)',fontWeight:700,color:'var(--navy)'}}>
                {service.title}
              </h2>
              <p className="leading-relaxed mb-8" style={{fontSize:'15.5px',color:'var(--muted)',lineHeight:1.9}}>
                {service.description}
              </p>

              {/* Stats */}
              {service.stats && (
                <div className="grid grid-cols-2 gap-4">
                  {service.stats.map((stat, i) => (
                    <div key={i} className="rounded-xl p-5 text-center" style={{background:'var(--saffron-pale)'}}>
                      <div className="font-bold" style={{fontFamily:'Playfair Display,serif',fontSize:'32px',color:'var(--saffron)'}}>{stat.value}</div>
                      <div className="text-sm mt-1" style={{color:'var(--saffron-dark)'}}>{stat.label}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Images */}
            {service.images && service.images.length > 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {service.images.map((img, i) => (
                  <div key={i} className="rounded-2xl overflow-hidden group" style={{boxShadow:'0 8px 24px rgba(13,27,62,0.10)'}}>
                    <img src={img} alt={`${service.title} ${i+1}`} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" style={{height:'240px'}}/>
                  </div>
                ))}
              </div>
            )}

            {/* CTA */}
            <div className="rounded-2xl p-8 flex flex-col sm:flex-row items-center justify-between gap-5" style={{background:'var(--navy)'}}>
              <div>
                <h3 className="font-bold text-white mb-1" style={{fontFamily:'Playfair Display,serif',fontSize:'20px'}}>Want to contribute to this initiative?</h3>
                <p className="text-sm" style={{color:'rgba(255,255,255,0.5)'}}>Your support can change lives. Volunteer or donate today.</p>
              </div>
              <div className="flex gap-3 flex-shrink-0">
                <Link to="/get-involved" className="text-white px-5 py-2.5 rounded-full text-sm font-semibold" style={{background:'var(--saffron)'}}>Get Involved</Link>
                <Link to="/donate" className="text-white px-5 py-2.5 rounded-full text-sm font-medium" style={{border:'1.5px solid rgba(255,255,255,0.3)'}}>Donate</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
